module.exports = __webpack_public_path__ + "img/vertical-distribute.88fee728.svg";